import {useTranslation} from 'react-i18next';
import {useDroppable} from '@dnd-kit/core';
import {SortableContext, horizontalListSortingStrategy} from '@dnd-kit/sortable';
import {Button} from '@tickchak/react-share/app';
import * as css from './LectureTimeRow.css';
import LectureCard from '../lectureCard/LectureCard';
import DropPlaceholder from '../dropPlaceholder/DropPlaceholder';
import ClockSettings from '../../../../assets/icons/ClockSettings';
import PlusThin from '../../../../assets/icons/PlusThin';
import {getSlotKey} from '../../hooks/timetableSort';
import {TLectureTimeGroup} from '../../../../redux/timetable/timetable.type';

interface LectureTimeRowProps {
    timeGroup: TLectureTimeGroup;
    expanded?: boolean;
    isFirst?: boolean;
    dropIdx?: number;
    onAddLecture?: (tsid: number | null) => void;
    onTicketsClick?: (lecture: TLectureTimeGroup['lectures'][number]) => void;
    onEditLecture?: (lecture: TLectureTimeGroup['lectures'][number]) => void;
}

function LectureTimeRow({
    timeGroup,
    expanded = true,
    isFirst = false,
    dropIdx,
    onAddLecture = () => {},
    onTicketsClick = () => {},
    onEditLecture = () => {},
}: LectureTimeRowProps) {
    const {time, tsid, lectures = []} = timeGroup;
    const {t} = useTranslation('timetable');
    const {setNodeRef} = useDroppable({id: getSlotKey(timeGroup), disabled: tsid == null});
    const itemIds = lectures.map(l => l.ttid);
    const handleAdd = () => onAddLecture(tsid ?? null);

    const cards = lectures.map(l => (
        <LectureCard
            key={l.ttid}
            lecture={l}
            expanded={expanded}
            onTicketsClick={() => onTicketsClick(l)}
            onEdit={() => onEditLecture(l)}
        />
    ));
    if(dropIdx != null) cards.splice(dropIdx, 0, <DropPlaceholder key="dp" expanded={expanded} />);

    return (
        <css.row>
            <css.timeLabel>
                {time}
                {isFirst && <ClockSettings />}
            </css.timeLabel>
            <css.lecturesArea ref={setNodeRef}>
                <css.addLecture expanded={expanded} onClick={handleAdd}>
                    <css.addButton>
                        <PlusThin />
                    </css.addButton>
                    <css.mobileBtnWrapper>
                        <Button variant="brand" size="chip" iconStart={<PlusThin />} onClick={handleAdd}>
                            {t('addHour')}
                        </Button>
                    </css.mobileBtnWrapper>
                </css.addLecture>
                <SortableContext items={itemIds} strategy={horizontalListSortingStrategy}>
                    {cards}
                </SortableContext>
            </css.lecturesArea>
        </css.row>
    );
}

export default LectureTimeRow;
